export default __webpack_public_path__ + "static/media/Citibank_logo.f03ede22.png";